/**
 * IP Table field definitions and column configurations
 * Used by IpResultsTable and IpTableSidebar components
 */

export const IP_TABLE_COLUMNS = [
  { key: 'location', label: 'Location', width: 90, widget: 'Country' },
  { key: 'ip', label: 'IP', width: 130, widget: 'IpWidget' },
  { key: 'hostnames', label: 'Hostnames', width: 200, widget: 'TagsBasic' },
  { key: 'netflow', label: 'Netflow', width: 150, widget: 'Netflow' },
  { key: 'submission_count', label: 'Comments', width: 120, widget: 'SubmissionCount' },
  { key: 'anonymization', label: 'Anonymization', width: 140, widget: 'Anonymization' },
  { key: 'osint.services', label: 'OSINT Mentions', width: 150, widget: 'OsintProviders' },
  { key: 'network.type', label: 'Network Type', width: 120, widget: 'Text' },
  { key: 'company.name', label: 'Company', width: 150, widget: 'Text' },
  { key: 'company.business', label: 'Company Business', width: 200, widget: 'Tags' }
]

/**
 * Get the default field order
 * @returns {string[]} Array of field keys in default display order
 */
export function getDefaultFieldOrder() {
  return IP_TABLE_COLUMNS.map(col => col.key)
}

/**
 * Get column configuration by field key
 * @param {string} key - The field key
 * @returns {Object|null} Column config or null if not found
 */
export function getColumnConfig(key) {
  return IP_TABLE_COLUMNS.find(col => col.key === key) || null
}

/**
 * Get label for a field
 * @param {string} key - The field key
 * @returns {string} The field label or the key itself if not found
 */
export function getFieldLabel(key) {
  const col = getColumnConfig(key)
  return col ? col.label : key
}

/**
 * Get all available field keys
 * @returns {string[]} Array of all field keys
 */
export function getAllFieldKeys() {
  return IP_TABLE_COLUMNS.map(col => col.key)
}
